export default "__VITE_ASSET__BEKL1OIj__"